export function timeAgoU(dateInput) {
  const date = new Date(dateInput);
  if (isNaN(date)) return '';
  const now = new Date();
  const diffSec = Math.floor((now - date) / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr  = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr  / 24);
  const diffWk  = Math.floor(diffDay / 7);

  if (diffSec < 60)  return 'just now';
  if (diffMin < 60)  return diffMin === 1 ? '1 min ago' : `${diffMin} mins ago`;
  if (diffHr  < 24)  return diffHr  === 1 ? '1 hour ago' : `${diffHr} hours ago`;
  if (diffDay < 7)   return diffDay === 1 ? 'yesterday' : `${diffDay} days ago`;
  if (diffWk  < 5)   return diffWk  === 1 ? '1 week ago' : `${diffWk} weeks ago`;

  // Older than ~1 month → show actual date
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
  });
}

export function getInitialsU(name) {
  return (name || '').split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
}